export enum Collection {
    CLINICIANS = "clincians",
    CLINICIAN_STATUS_CHANGES = "clinician_status_changes",
    SUPERVISORS = "supervisors",
    METHODOLOGY = "methodology",
    EXPERIENCELEVELS = "experience_levels",
    CLIENTS = "clients",
    ARCHIVED_CLIENTS = "archived_clients",
    ACL = "acl",
    HISTORY = "history",
    REPORT = "report",
    OUTBOUND_EMAILS = "outbound_emails",
    RESERVED_APPOINTMENTS = "reserved_appointments",
    RESERVED_APPOINTMENT_LOG = "reserved_appointment_log",
    LOCATIONS = "locations",
    OUTBOUND_REMINDER_EMAILS = "outbound_email_reminders",
    PAUSED_APPOINTMENTS = "paused_appointments",
    STATS = "stats",
    REQUESTED_SERVICES = "requested_services",
    DEPARTMENTS = "departments",
    CLINICIAN_SERVICE_SELECTION = "clinician_service_selection",
    OFFICE_WINDOW_REQUESTS = "office_windows_requests",
    OFFICE_MANAGER_ACTIVITIES = "office_manager_activities",
    OFFICE_WINDOWS = "office_windows",
    OUTBOUND_SMS = "outbound_sms",
    CONSENT_FORM_LINKS = "consent_form_links",
    EMAIL_SIGNATURES = "email_signatures",
    CLIENT_ASSIGNMENT_LOG = "client_assignment_log",
    CALENDAR_AUTH_TOKEN = "calendar_auth_token",
    DELETED_CLINICIANS = "deleted_clinicians",
    COMMUNICATION_SUMMARIES = "communication_summaries",
    CLIENT_TAG_ACTIVITIES = "client_tag_activities",
    COMMUNICATION_NOTES = "communication_notes",
}

export enum UserManagementMenuOptions {
    EDIT_USER = "Edit user",
    BLOCK_USER = "Block user",
    DELETE_USER = "Delete user",
}
